var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1820px",
    height: "1820px",
    viewBox: "0 0 1820 1820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8898AA",
    strokeWidth: 100,
    cx: 910,
    cy: 910,
    r: 860
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar-refresh",
    transform: "translate(458.000000, 435.000000)",
    fill: "#8898AA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760.421053,95 L712.894737,95 L712.894737,0 L617.842105,0 L617.842105,95 L237.631579,95 L237.631579,0 L142.578947,0 L142.578947,95 L95.0526316,95 C42.7736842,95 0,137.75 0,190 L0,855 C0,907.25 42.7736842,950 95.0526316,950 L522.789474,950 C494.273684,926.25 470.510526,893 451.5,855 L95.0526316,855 L95.0526316,332.5 L760.421053,332.5 L760.421053,456 C793.689474,460.75 826.957895,470.25 855.473684,489.25 L855.473684,190 C855.473684,137.75 812.7,95 760.421053,95 M712.894737,546.25 C765.173684,546.25 812.7,565.25 845.968421,603.25 L903,546.25 L903,736.25 L712.894737,736.25 L798.442105,650.75 C774.678947,631.75 746.163158,617.5 712.894737,617.5 C646.357895,617.5 594.078947,669.75 594.078947,736.25 C594.078947,802.75 646.357895,855 712.894737,855 C750.915789,855 784.184211,836 807.947368,807.5 L888.742105,807.5 C860.226316,878.75 793.689474,926.25 712.894737,926.25 C608.336842,926.25 522.789474,840.75 522.789474,736.25 C522.789474,631.75 608.336842,546.25 712.894737,546.25 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.799a2467c997f0fa812bbdf2bf9aa376.svg";
export { ForwardRef as ReactComponent };